(function (root, factory) {
  const api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.SakBundleCore = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const MIN_SIZE = 2;
  const MAX_SIZE = 4;
  const MAX_NAME_LENGTH = 12;

  function normalizeName(value) {
    let text = String(value || '').trim();

    if (/\.sak$/i.test(text)) {
      text = text.slice(0, -4).trim();
    }

    return Array.from(text).slice(0, MAX_NAME_LENGTH).join('');
  }

  function fullCustomText(value) {
    const name = normalizeName(value);
    return name ? name + '.sak' : '';
  }

  function optionKey(values) {
    return Array.isArray(values) ? values.map(String).join('\u001f') : '';
  }

  function findVariant(variants, selectedOptions) {
    if (
      !Array.isArray(variants) ||
      !Array.isArray(selectedOptions) ||
      selectedOptions.length === 0 ||
      selectedOptions.some((value) => !value)
    ) {
      return null;
    }

    const matches = variants.filter((variant) => optionKey(variant.options) === optionKey(selectedOptions));
    return matches.length === 1 ? matches[0] : null;
  }

  function isPersonalised(options) {
    return (options || []).some((value) => /^personali[sz]ed$/i.test(String(value)));
  }

  function discountForCount(count) {
    return { 2: 10, 3: 15, 4: 20 }[Number(count)] || 0;
  }

  function validateCards(cards, variants) {
    const errors = [];

    if (!Array.isArray(cards) || cards.length < MIN_SIZE || cards.length > MAX_SIZE) {
      return {
        valid: false,
        errors: [{ slot: 0, field: 'size', message: 'Choose a bundle of 2, 3, or 4 bags.' }],
      };
    }

    cards.forEach((card, index) => {
      const slot = index + 1;
      const variant = findVariant(variants, card.options);

      if (!variant) {
        errors.push({ slot, field: 'variant', message: 'Choose all options for bag ' + slot + '.' });
      } else if (!variant.available) {
        errors.push({
          slot,
          field: 'variant',
          message: 'That combination is unavailable for bag ' + slot + '.',
        });
      }

      if (isPersonalised(card.options) && !normalizeName(card.name)) {
        errors.push({ slot, field: 'name', message: 'Enter a name for bag ' + slot + '.' });
      }
    });

    return { valid: errors.length === 0, errors };
  }

  function buildCartItems(cards, variants, bundleId) {
    const validation = validateCards(cards, variants);

    if (!validation.valid) {
      throw new Error(validation.errors[0].message);
    }

    return cards.map((card, index) => {
      const variant = findVariant(variants, card.options);
      const properties = {
        _sak_bundle_id: String(bundleId),
        _sak_bundle_slot: String(index + 1),
      };

      if (isPersonalised(card.options)) {
        properties['Custom text'] = fullCustomText(card.name);
      }

      return { id: variant.id, quantity: 1, properties };
    });
  }

  return {
    MIN_SIZE,
    MAX_SIZE,
    MAX_NAME_LENGTH,
    normalizeName,
    fullCustomText,
    findVariant,
    isPersonalised,
    discountForCount,
    validateCards,
    buildCartItems,
  };
});
